<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_shutter') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_shutterMode') }}
            span(slot="value") {{ shutterMode }}
        game-preview-setting(v-if="parameters.mode !== 'text'")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_groups') }}
            span(slot="value") {{ parameters.selectedGroups.join('; ') }}
        game-preview-setting(v-for="(group, index) in lettersForGroups" :key="index")
            span(slot="name") {{ group.name }}
            span(slot="value") {{ group.letters.join('; ') }}
        game-preview-setting(v-if="parameters.mode !== 'text'")
            span(slot="name") {{ amountOfItemsString }}
            span(slot="value") {{ parameters.amountOfItemsInColumn }}
        game-preview-setting(v-if="parameters.mode === 'text'")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfWordsInColumn') }}
            span(slot="value") {{ parameters.amountOfWordsInRow }}
        game-preview-setting(v-if="parameters.textLabel")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_textLabel') }}
            span(slot="value") {{ parameters.textLabel }}
        game-preview-setting
           span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_shutterSpeed') }}
           span(slot="value") {{ parameters.shutterSpeed.value }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_wordsPerMinute') }}
        game-preview-setting
           span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_accentedWords') }}
           span(slot="value")
              template(v-if="parameters.accentedWords") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
              template(v-else) {{ $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
        game-preview-setting
           span(slot="name") {{ invertedItemsString }}
           span(slot="value")
              template(v-if="parameters.invertedItems") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
              template(v-else) {{ $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
        game-preview-setting
           span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_shutterSpeedIncrease') }}
           span(slot="value")
              template(v-if="parameters.shutterSpeedIncrease") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
              template(v-else) {{ $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
        game-preview-setting(v-if="parameters.shutterSpeedIncrease")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_maxSpeed') }}
            span(slot="value") {{ parameters.shutterMaxSpeed.value }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_wordsPerMinute') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_metronome') }}
            span(slot="value") {{ formattedBPM }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
        computed: {
            shutterMode () {
                switch (this.parameters.mode) {
                    case ("wordColumn"):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeWordColumn');
                    case ("syllableColumn"):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeSyllableColumn');
                    case ("text"):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeText');
                }
            },
            amountOfItemsString () {
                return this.parameters.mode === 'wordColumn'
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWordsInColumn')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_amountOfSyllablesInColumn');
            },
            invertedItemsString () {
                return this.parameters.mode === 'syllableColumn'
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_invertedSyllables')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_invertedWords')
                return this.parameters.mode === 'wordColumn' ? this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeWordColumn')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeText')
            },
            formattedBPM () {
                return this.parameters.metronomeSpeed
                    ? `${this.parameters.metronomeSpeed} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_bpm')
                    : this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated');
            },
            lettersForGroups() {
                let newArray = [];
                let groupsWithLettersSetting = ['Группа 1 (ма, ро)', 'Группа 2 (мя, ки)', 'Группа 3 (ам, ор)', 'Группа 4 (ям, ер)'];
                groupsWithLettersSetting.forEach(key => {
                    if (this.parameters[key] && this.parameters.selectedGroups.find(item => item.includes(key))) {
                        newArray.push({
                            name: key,
                            letters: this.parameters[key],
                        });
                    }
                });
                this.parameters.lettersForGroups = newArray;
                return newArray;
            }
        }
      }
</script>
